import React, { useEffect, useMemo, useRef } from 'react';
import Button from '../../../../../../../generic-components/Button';
import Heading from '../../../../../../../generic-components/Heading';
import { convertValueToUSD } from '../../../../../../../helpers/currency.helper';
import { IProduct } from '../../../../types/types';
import { ReactComponent as SuccessIcon } from '../../../../../../../assets/icons/svg/shared/ic-shared-checkmark.svg';
import { ReactComponent as PlusIcon } from '../../../../../../../assets/svg/plus-new.svg';

interface IProps {
  keyword: string;
  onProductSelection: (product: IProduct) => void;
  onProductCreation: () => void;
  products: IProduct[];
  selectedProductsIds: string[];
  autoAddItemId?: string;
  onClose: () => void;
}

export const ProductList = ({
  keyword,
  onProductSelection,
  products,
  selectedProductsIds,
  onProductCreation,
  autoAddItemId,
  onClose,
}: IProps) => {
  const elWrapper = useRef<HTMLDivElement>(null);

  const handleProductSelection = (product: IProduct) => {
    onProductSelection(product);
  };
  useEffect(() => {
    if (autoAddItemId && products) {
      const itemIdx = products?.findIndex((i) => i.serviceItemId === autoAddItemId);
      if (itemIdx !== -1) {
        handleProductSelection(products[itemIdx]);
      }
    }
  }, [autoAddItemId, products]);
  useEffect(() => {
    window.addEventListener('click', (e: any) => {
      if (!elWrapper || !e || e.target.dataset.trigger) return;
      if (!(e.target && elWrapper.current?.contains(e.target))) {
        onClose();
      }
    });
    return () => {
      window.removeEventListener('click', () => {});
    };
  }, []);
  const filteredProducts = useMemo(
    () => products?.filter((p: IProduct) => p.name?.toLowerCase().includes(keyword.toLowerCase())) || [],
    [keyword, products],
  );

  const actionButtonTitle = useMemo(() => {
    if (!filteredProducts.length && keyword) {
      return `Create new item "${keyword}"`;
    }
    return 'Create new item';
  }, [filteredProducts.length, keyword]);

  return (
    <div
      ref={elWrapper}
      className='absolute translate-y-[100%] z-[999] border border-bw03 bottom-0 left-0 w-full bg-bw00 shadow-chatBotButton flex flex-col rounded-[8px]'
    >
      {filteredProducts.length > 0 && (
        <div className='flex flex-col max-h-[220px] overflow-y-auto'>
          {filteredProducts.map((p, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <div key={`${p.serviceItemId}${idx}`} className='hover:bg-bw02 flex flex-row border-b border-bw03'>
              <Button
                childElement={
                  <div className='w-full flex items-center justify-between '>
                    <div className='flex flex-col items-start'>
                      <Heading
                        title={p.name}
                        className='leading-[20px] font-metricMedium text-[14px] text-bw08 text-left max-w-[260px] truncate pr-[8px]'
                      />
                      <Heading
                        title={`Price ${convertValueToUSD(p.amount, 2)}`}
                        className='leading-[20px] font-metric text-[14px] text-bw06'
                      />
                    </div>
                  </div>
                }
                id=''
                onClick={() => {
                  if (!selectedProductsIds.includes(p.serviceItemId || '')) {
                    onProductSelection(p);
                  }
                }}
                className=' flex flex-col w-full gap-[2px] px-[14px] py-[8px] '
              />
              {selectedProductsIds.includes(p.serviceItemId || '') ? (
                <div className='flex items-center mx-[10px]'>
                  <SuccessIcon />
                </div>
              ) : (
                <div />
              )}
            </div>
          ))}
        </div>
      )}

      {!filteredProducts.length && keyword && (
        <Heading title='No Item Found' className='font-metric text-[1rem] text-bw08 text-center w-full py-[12px]' />
      )}

      <Button
        onClick={onProductCreation}
        className='w-full hover:bg-bw01 py-[10px] px-[14px] shadow-light rounded-[8px]'
        id='createNewItem'
        childElement={
          <div className='flex gap-[6px]'>
            <PlusIcon className='w-[16px] text-action03 ' />
            <Heading
              title={actionButtonTitle}
              className={`font-metric  max-w-[30ch] truncate text-[14px] text-action03 hover:underline ${!filteredProducts.length && keyword ? 'w-full' : 'w-fit'} `}
            />
          </div>
        }
      />
    </div>
  );
};
